if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const activeSlide = slides[activeIndex];
      if (!activeSlide) return;

      const activeVideo =
        activeSlide.dataset.slideType === "video_slide" ? activeSlide.querySelector("video") : null;

      // Pause every other video in this slider, including Swiper's loop clones.
      // Never pause the video that is about to be shown.
      this.querySelectorAll(".swiper-slide video").forEach((video) => {
        if (video !== activeVideo && !video.paused) video.pause();
      });

      if (activeVideo) {
        activeVideo.loop = true;
        activeVideo.muted = true;
        if (activeVideo.paused) {
          const playPromise = activeVideo.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});
        }
      }

      this.lastVideo = activeVideo;
    }

    onBlockSelect(ev) {
      // Only react to blocks that belong to this slideshow section.
      if (!ev.detail || ev.detail.sectionId !== this.id) return;
      const index = Number(ev.target.dataset.slide);
      if (Number.isNaN(index)) return;
      this.slider && this.slider.slideToLoop(index);
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
